module.exports = __webpack_public_path__ + "static/media/image-768.81415913.webp";